var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Icon',{attrs:{"tooltip":"Novas funcionalidades","placement":"bottom"}},[_c('Gift',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-features",modifiers:{"sidebar-features":true}}],staticClass:"gift"})],1),_c('Home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }